/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { useSelect } from '@wordpress/data';
import { useMemo } from '@wordpress/element';
import { SUBSCRIPTIONS_STORE_NAME as STORE_NAME } from '../../constants';

/**
 * Internal dependencies
 */
import subscriptionIcon from '../../common/images/subscription-icon.svg';
import timeslotIcon from '../../common/images/timeslot-icon.svg';

/**
 * SubscriptionSelectedSlot component
 * 
 * Displays the selected delivery slot information for subscription products
 */
const SelectedSlot = ({ type }) => {
	const reservedSlot = useSelect(select => select(STORE_NAME).getReservedSlot(type));
	
	const formattedReservedSlot = useMemo(() => {
		if ( ! reservedSlot ) {
			return __('No delivery slot selected', 'jckwds');
		}
		
		if ( ! reservedSlot.timeslot_formatted ) {
			return reservedSlot.date_formatted;
		}

		return reservedSlot.date_formatted + ' @ ' + reservedSlot.timeslot_formatted;
	}, [reservedSlot]);

	if (!formattedReservedSlot) {
		return (
			<div className="wds-fieldbox-selector__item">
				<div className="wds-fieldbox__item-icon">
					{ type === 'subscription' ? <img src={subscriptionIcon} alt="Subscription icon" /> : <img src={timeslotIcon} alt="Timeslot icon" /> }
				</div>
				<span className="wds-fieldbox__item-title">{__('No delivery slot selected', 'jckwds')}</span>
			</div>
		);
	}
	
	return (
		<div className="wds-fieldbox-selector__item">
			<div className="wds-fieldbox-selector__item-icon">
				{ type === 'subscription' ? <img src={subscriptionIcon} alt="Subscription icon" /> : <img src={timeslotIcon} alt="Timeslot icon" /> }
			</div>
			<div className="wds-fieldbox-selector__item-content">
				<div className="wds-fieldbox-selector__item-value">
					{formattedReservedSlot}
				</div>
			</div>
		</div>
	);
};

export default SelectedSlot;